import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultIcon", "objectTypeId", "objectId", "crmSize"];
import PortalIdParser from 'PortalIdParser';
import { Avatar } from 'avatar-components/Avatar';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { View } from 'foundations-components/components/View';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { specialtyColor } from 'foundations-theming-specialty/utils';

// Not intended for use outside ai-rendering-library.
import { jsx as _jsx } from "react/jsx-runtime";
const CrmCitationIcon = _ref => {
  let {
      defaultIcon,
      objectTypeId,
      objectId,
      crmSize = 16
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const portalId = PortalIdParser.get();
  const isValidForAvatar = objectId && portalId && (objectTypeId === CONTACT_TYPE_ID || objectTypeId === COMPANY_TYPE_ID);
  if (isValidForAvatar) {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: `${crmSize}px`,
      blockSize: `${crmSize}px`,
      children: /*#__PURE__*/_jsx(Avatar, {
        marginBlockEnd: "0",
        size: "responsive",
        type: "vid",
        lookup: {
          vid: Number(objectId)
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(IconCircle, Object.assign({
    backgroundColor: specialtyColor('breeze-icon-primary-default'),
    borderColor: specialtyColor('breeze-border-tertiary-default'),
    borderWidth: "100",
    borderStyle: "solid",
    color: specialtyColor('breeze-icon-icon-button-default')
  }, rest, {
    icon: defaultIcon
  }));
};
export default CrmCitationIcon;